module.exports = __webpack_public_path__ + "static/img/h2-3.2a4a292.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner1/h2-3.png
// module id = XlWJ
// module chunks = 1